import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateAccountSettingsPwasMutation = createMutationHook(
  MembershipsCreatorApiClient.updateAccountSettingsPwas,
  {
    mutationKey: ['updateAccountSettingsPwas'],
  },
)
